module.exports = __webpack_public_path__ + "img/22.81a6a01c.jpg";